import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { TableResponsiveTrainingsComponent } from './table-responsive-trainings.component';

@NgModule({
  declarations: [
    TableResponsiveTrainingsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    AngularMaterialModule
  ],
  exports: [
    TableResponsiveTrainingsComponent
  ]
})
export class TableResponsiveTrainingsModule { } 